config.$inject = ['$stateProvider']
function config($stateProvider) {
  $stateProvider
    .state('login', {
      url: '/login',
      template: '<login return-state="returnState"></login>',
      params: {
        returnState: undefined
      },
      controller: ['$scope', '$stateParams', function ($scope, $stateParams) {
        $scope.returnState = $stateParams.returnState
      }]
    })
}

export default config


